import { Coins } from '../Coins';
import { ParamChange } from '..';
import { Convert } from '../../util/convert';
import { Dec } from '../numeric';

export interface DepositParams {
  min_deposit: Coins;
  max_deposit_period: number;
}

export namespace DepositParams {
  export interface Data {
    min_deposit: Coins.Data;
    max_deposit_period: string;
  }
}

export interface VotingParams {
  voting_period: number;
}

export namespace VotingParams {
  export interface Data {
    voting_period: string;
  }
}

export interface TallyParams {
  quorum: Dec;
  threshold: Dec;
  veto: Dec;
}

export namespace TallyParams {
  export interface Data {
    quorum: string;
    threshold: string;
    veto: string;
  }
}

type DepositParamsParamChange = ParamChange.Type<
  'gov',
  'depositparams',
  DepositParams
>;

type VotingParamsParamChange = ParamChange.Type<
  'gov',
  'votingparams',
  VotingParams
>;

type TallyParamsParamChange = ParamChange.Type<
  'gov',
  'tallyparams',
  TallyParams
>;

export type GovParamChange =
  | DepositParamsParamChange
  | VotingParamsParamChange
  | TallyParamsParamChange;

export namespace GovParamChange {
  export type Data =
    | ParamChange.Data.Type<DepositParamsParamChange>
    | ParamChange.Data.Type<VotingParamsParamChange>
    | ParamChange.Data.Type<TallyParamsParamChange>;
}

export interface GovParamChanges {
  gov?: {
    depositparams?: DepositParams;
    votingparams?: VotingParams;
    tallyparams?: TallyParams;
  };
}

export namespace GovParamChanges {
  export const ConversionTable = {
    gov: {
      depositparams: [Convert.toDepositParams, Convert.serializeDepositParams],
      votingparams: [Convert.toVotingParams, Convert.serializeVotingParams],
      tallyparams: [Convert.toTallyParams, Convert.serializeTallyParams],
    },
  };
}
